import { Avatar } from "@material-ui/core";
import { styled } from "@material-ui/core/styles";

const ExtraSmallAvatar = styled(Avatar)(({ theme }) => ({
  height: theme.spacing(3),
  width: theme.spacing(3),
}));

export default ExtraSmallAvatar;
